
import { store }                from 'index';
import { SET_COMPONENTS_STATE } from 'actions';
import { objType }              from 'types';

const handleKeyClick = (val: string) => {

    const state              = store.getState();
    const componentsState    = state.components;
    const { textInput }      = componentsState;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))

    if ( componentsState.success ) {
        return
    }


    let newTextInput = val !== '-1' ? textInput + val : textInput.slice(0, textInput.length-1)

    if ( componentsState.updateFailType ) {
        newTextInput = val;
    }

    if ( +newTextInput > 999 ) {
        return
    }

    let payload = { 
        ...componentsState,
        textInput:      newTextInput,
        updateFailType: false,
        hideFeedBack:   true,
    };

    setComponentsState(payload);
}

export default handleKeyClick